import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Callout } from '@/shared/ui';
import styles from './StrategyNudgeBanner.module.css';

/**
 * Purple strategy nudge banner shown in the Connected ads state.
 * `strategy` drives the copy: prompt to create vs. finish an in-progress draft.
 */
export function StrategyNudgeBanner({
  strategy = 'not_started',
}: {
  strategy?: 'not_started' | 'in_progress';
}) {
  const navigate = useNavigate();

  if (strategy === 'in_progress') {
    return (
      <Callout variant="accent">
        Your strategy is in progress — finish it to unlock campaigns tailored to your practice.{' '}
        <button type="button" className={styles.link} onClick={() => navigate('/strategy')}>
          Complete strategy →
        </button>
      </Callout>
    );
  }
  return (
    <Callout variant="accent">
      Your ads are running, but without a strategy you’re optimizing blind.{' '}
      <button type="button" className={styles.link} onClick={() => navigate('/strategy')}>
        Create a strategy →
      </button>
    </Callout>
  );
}

/**
 * Green "Strategy Active" banner shown in the Strategy-linked state.
 */
export function StrategyActiveBanner({ count, onSetUp }: { count: number; onSetUp: () => void }) {
  return (
    <Callout
      variant="success"
      actions={
        <button type="button" className={styles.activeCta} onClick={onSetUp}>
          Set up campaigns →
        </button>
      }
    >
      <span className={styles.activeLeft}>
        <span className={styles.activePill}>Strategy Active</span>
        <span>
          {count} campaign{count === 1 ? '' : 's'} recommended — choose how to run them
        </span>
      </span>
    </Callout>
  );
}
